import React, { useMemo } from 'react'

import { Avatar, Label } from '@hhgtech/hhg-components/components'
import { getSocialList, theme } from '@hhgtech/hhg-components/misc'
import { useIntl } from 'react-intl'

import { useRouterExtend } from 'hooks/useRouterExtend'
import ShareExtension from 'public/svg/linkShareExtension.svg'

import {
  StyledContainer,
  StyledHeading,
  StyledSocialContainer,
} from './index.styled'

export type Props = {
  isMobile?: boolean
  className?: string
  shareUrl?: string
}

const ToolsShareSocial = ({ className, shareUrl = '', isMobile }: Props) => {
  const { formatMessage: f } = useIntl()

  let toShareUrl = encodeURIComponent(shareUrl)

  if (toShareUrl === '' && typeof window !== 'undefined') {
    toShareUrl =
      typeof window !== 'undefined'
        ? encodeURIComponent(window.location.href)
        : ''
  }

  const { locale } = useRouterExtend()
  const socialList = useMemo(
    () =>
      getSocialList({ shareUrl, locale }).filter(
        (s) => !s.allowedLocales || s.allowedLocales.includes(locale),
      ),
    [locale, shareUrl],
  )

  const shareExtension = () => {
    if (navigator.share) {
      const url = window.location.href
      // const canonicalElement: any = document.querySelector(
      //   'link[rel=canonical]',
      // )

      // if (canonicalElement !== null) {
      //   url = canonicalElement.href
      // }
      navigator
        .share({
          title: 'My BMI result',
          text: url,
          url: url || '/',
        })
        .then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing', error))
    }
  }

  return (
    <StyledContainer className={className}>
      {isMobile && (
        <StyledHeading>
          <Label
            size="label1"
            htmlFor=""
            style={{
              color: theme.colors.gray400,
              fontWeight: 'bold',
            }}
          >
            {f({
              id: 'tools.shareResultOn',
              defaultMessage: 'Share result on',
            })}
          </Label>
        </StyledHeading>
      )}
      <StyledSocialContainer>
        {!isMobile && (
          <StyledHeading>
            <Label
              size="label1"
              htmlFor=""
              style={{
                color: theme.colors.gray400,
                fontWeight: 'bold',
              }}
            >
              {f({
                id: 'tools.shareResultOn',
                defaultMessage: 'Share result on',
              })}
            </Label>
          </StyledHeading>
        )}
        {socialList.map((social, index) => (
          <Avatar
            key={index}
            className="share-icon"
            avatarImg={
              <a
                target="_blank"
                href={social.href}
                data-event-category="Social Share"
                data-event-action={social.name}
                data-event-label={social.href}
              >
                {social.icon}
              </a>
            }
            type="square"
          />
        ))}
        {isMobile && (
          <Avatar
            className="share-icon-1"
            avatarImg={
              <div
                // data-event-category=" Share"
                // data-event-action=""
                // data-event-label={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
                // target="_blank"
                // href={``}
                onClick={shareExtension}
              >
                <ShareExtension />
              </div>
            }
            type="square"
          />
        )}
      </StyledSocialContainer>
    </StyledContainer>
  )
}

export { ToolsShareSocial }
